var _g, _g2, _rect, _rect2, _rect3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 470,
    viewBox: "0 0 283 470",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1160_15974)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 282.875,
    y: 0.000198364,
    width: 469.892,
    height: 282.875,
    rx: 65,
    transform: "rotate(90 282.875 0.000198364)",
    fill: "url(#paint0_radial_1160_15974)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1160_15974)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.375,
    y: 7.5002,
    width: 454.892,
    height: 267.875,
    rx: 57.6839,
    transform: "rotate(90 275.375 7.5002)",
    stroke: "url(#paint1_linear_1160_15974)",
    strokeWidth: 15
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 266.26,
    y: 15.7729,
    width: 437.741,
    height: 249.741,
    rx: 47.3704,
    transform: "rotate(90 266.26 15.7729)",
    stroke: "url(#paint2_linear_1160_15974)",
    strokeWidth: 3.25919
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 246.814,
    y: 32.141,
    width: 405.297,
    height: 210.759,
    rx: 36.6659,
    transform: "rotate(90 246.814 32.141)",
    stroke: "url(#paint3_linear_1160_15974)",
    strokeWidth: 1.6296
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 242.583,
    y: 35.8553,
    width: 398.181,
    height: 202.299,
    rx: 33.8141,
    transform: "rotate(90 242.583 35.8553)",
    stroke: "url(#paint4_linear_1160_15974)",
    strokeWidth: 0.814798
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1160_15974",
    x: -45.1695,
    y: -45.1694,
    width: 328.045,
    height: 515.062,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -45.1695,
    dy: -45.1695
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 112.924
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1160_15974"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1160_15974",
    x: 0,
    y: 0.000183105,
    width: 282.875,
    height: 469.892,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.25919
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.85 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1160_15974"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1160_15974",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(437.518 162.486) rotate(-20.947) scale(454.54 442.927)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FC653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22823B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1160_15974",
    x1: 260.608,
    y1: 141.438,
    x2: 780.489,
    y2: 141.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D2125"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1160_15974",
    x1: 246.991,
    y1: 140.643,
    x2: 734.906,
    y2: 140.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18242A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1160_15974",
    x1: 228.345,
    y1: 137.52,
    x2: 678.562,
    y2: 137.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1160_15974",
    x1: 224.082,
    y1: 137.005,
    x2: 665.525,
    y2: 137.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182A1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#213928"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable2);
export default __webpack_public_path__ + "static/media/table_2.aeb84d7bcbcf36f5cde67aac04a1923b.svg";
export { ForwardRef as ReactComponent };